'use client'

import { SegmentError } from '../../../_error-boundaries/segment-error.client'

type AccommodationDetailErrorProps = {
  error: Error & { digest?: string }
  reset: () => void
}

export default function AccommodationDetailError(props: AccommodationDetailErrorProps) {
  return <SegmentError boundary="accommodation-detail" {...props} />
}
